export default [
    {
        path: "/manifestMake/list",
        name: "ManifestMakeList",
        component: () => import("@/views/ManifestMake/list"),
        hidden: true,
        meta: {
            title: "舱单列表",
            activeMenu: "/manifestMake/list",
            keepAlive: true,
        },
    },
    {
        path: "/manifestMake/rsn",
        name: "ManifestMakeRsn",
        component: () => import("@/views/ManifestMake/rsn"),
        hidden: true,
        meta: {
            title: "收发通",
            activeMenu: "/manifestMake/rsn",
        },
    },
    {
        path: "/manifestMake/template",
        name: "ManifestMakeTemplate",
        component: () => import("@/views/ManifestMake/template"),
        hidden: true,
        meta: {
            title: "舱单模板",
            activeMenu: "/manifestMake/template",
            keepAlive: true,
        },
    },
    {
        path: "/manifestMake/mailAccount",
        name: "ManifestMakeMailAccount",
        component: () => import("@/views/ManifestMake/mailAccount"),
        hidden: true,
        meta: {
            title: "邮箱管理",
            activeMenu: "/manifestMake/mailAccount",
        },
    },
    {
        path: "/manifestMake/vgmTemplate",
        name: "ManifestMakeVgmTemplate",
        component: () => import("@/views/ManifestMake/vgmTemplate"),
        hidden: true,
        meta: {
            title: "VGM信息模板",
            activeMenu: "/manifestMake/vgmTemplate",
        },
    },
    {
        path: "/manifestMake/edit",
        name: "ManifestMakeEdit",
        component: () => import("@/views/ManifestMake/edit.vue"),
        hidden: true,
        meta: {
            title: "宁波舱单编辑",
            activeMenu: "/manifestMake/list",
        },
    },
    {
        path: "/manifestMake/preRecognize/list",
        name: "ManifestPreRecognizeList",
        component: () => import("@/views/ManifestMake/PreRecognize/list/index.vue"),
        hidden: true,
        meta: {
            title: "舱单预录列表",
            activeMenu: "/manifestMake/preRecognize/list",
            keepAlive: true,
        },
    },
    {
        path: "/manifestMake/preRecognize/edit",
        name: "ManifestPreRecognizeEdit",
        component: () => import("@/views/ManifestMake/PreRecognize/edit.vue"),
        hidden: true,
        meta: {
            title: "舱单预录编辑",
            activeMenu: "/manifestMake/preRecognize/list",
        },
    },
];
